// extracted by mini-css-extract-plugin
export default {"tag":"StageTag_tag__CTmOO","name":"StageTag_name__LLjG3"};